import { JavaScriptPlugin, MustachePlugin } from '@rehaje/lowcode'
import { useViewModel } from '@rehaje/react'
import { useEffect, useMemo } from 'react'

import { createForm } from '../factories'
import { SchemaModel, ValuableModel } from '../models'

import type { CreateFormProps } from '../factories'
import type { TypedSchema } from '@rehaje/core'

export interface UseFormProps extends CreateFormProps {
  /**
   * 自动连接父级表单，默认不连接
   */
  autoConnectParent?: boolean

  /**
   * 是否使用 Suspense 提前加载缓存
   * 默认加载缓存
   */
  suspense?: boolean
}

export const useForm = (
  specific: TypedSchema,
  props?: UseFormProps,
  deps: any[] = []
) => {
  if (props?.suspense !== false) {
    MustachePlugin.useMustacheStorage()
    JavaScriptPlugin.useJavaScriptStorage()
  }
  const parent = useViewModel()

  // eslint-disable-next-line react-hooks/use-memo
  const store = useMemo(() => createForm(specific, props), deps)
  const form = store.model?.find<ValuableModel>(
    (model) => model instanceof ValuableModel
  )?.form
  useEffect(() => {
    if (props?.autoConnectParent) {
      const model = store.model
      if (parent && model instanceof SchemaModel) {
        model.connect(parent)
      }
    }
  }, [store, parent])
  return form
}
